import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useCallback } from 'react';
export var usePlay = function usePlay(currentAudio) {
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(audioRef) {
      var _currentAudio$current;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // In case a different audio is being played we need to pause it first.
              if (currentAudio.current !== audioRef) {
                (_currentAudio$current = currentAudio.current) == null ? void 0 : _currentAudio$current.pause();
                currentAudio.current = audioRef;
              }

              _context.next = 3;
              return currentAudio.current.play();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [currentAudio]);
};
export var useUnregister = function useUnregister(currentAudio) {
  return useCallback(function (audioRef) {
    if (currentAudio.current === audioRef) {
      var _currentAudio$current2;

      // In order to enable garbage collector on the audio object we need to pause it and remove its references.
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement/Audio#memory_usage_and_management
      (_currentAudio$current2 = currentAudio.current) == null ? void 0 : _currentAudio$current2.pause();
      currentAudio.current = null;
    }
  }, [currentAudio]);
};